export const initialActiveItemState = {
  activeItem: null,
};

export default (state, action) => {
  switch (action.type) {
    case 'ACTIVE_ITEM_INITIALIZE':
      return { ...state, ...action.state };
    case 'ACTIVE_ITEM_SET_ACTIVE_ITEM':
      return { ...state, activeItem: action.activeItem };
    default:
      return { ...state };
  }
};
